import { render, staticRenderFns } from "./BulmaTable.vue?vue&type=template&id=17951e0d&scoped=true"
import script from "./BulmaTable.vue?vue&type=script&lang=js"
export * from "./BulmaTable.vue?vue&type=script&lang=js"
import style0 from "./BulmaTable.vue?vue&type=style&index=0&id=17951e0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17951e0d",
  null
  
)

export default component.exports